var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 201,
    viewBox: "0 0 136 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1074_13624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61 89C61 73.536 73.536 61 89 61H136V140H89C73.536 140 61 127.464 61 112V89Z",
    fill: "#1A5D1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 87.625C103.795 87.625 105.25 86.2259 105.25 84.5C105.25 82.7741 103.795 81.375 102 81.375C100.205 81.375 98.75 82.7741 98.75 84.5C98.75 86.2259 100.205 87.625 102 87.625Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.167 85.4168V83.5835C91.167 82.5002 92.0878 81.6043 93.2253 81.6043C95.1862 81.6043 95.9878 80.271 95.002 78.6356C94.4387 77.6981 94.7745 76.4793 95.7603 75.9377L97.6345 74.9064C98.4903 74.4168 99.5953 74.7085 100.104 75.5314L100.224 75.7293C101.199 77.3647 102.802 77.3647 103.788 75.7293L103.907 75.5314C104.416 74.7085 105.521 74.4168 106.377 74.9064L108.251 75.9377C109.237 76.4793 109.573 77.6981 109.009 78.6356C108.024 80.271 108.825 81.6043 110.786 81.6043C111.913 81.6043 112.844 82.4897 112.844 83.5835V85.4168C112.844 86.5002 111.924 87.396 110.786 87.396C108.825 87.396 108.024 88.7293 109.009 90.3647C109.573 91.3127 109.237 92.521 108.251 93.0627L106.377 94.0939C105.521 94.5835 104.416 94.2918 103.907 93.4689L103.788 93.271C102.813 91.6356 101.209 91.6356 100.224 93.271L100.104 93.4689C99.5953 94.2918 98.4903 94.5835 97.6345 94.0939L95.7603 93.0627C94.7745 92.521 94.4387 91.3022 95.002 90.3647C95.9878 88.7293 95.1862 87.396 93.2253 87.396C92.0878 87.396 91.167 86.5002 91.167 85.4168Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3602 126L90.3932 105.7H94.5692L102.544 126H97.5562L93.7282 115.705C93.5735 115.299 93.4188 114.864 93.2642 114.4C93.1095 113.936 92.9548 113.462 92.8002 112.979C92.6455 112.476 92.4908 111.993 92.3362 111.529C92.2008 111.046 92.0848 110.601 91.9882 110.195L92.8582 110.166C92.7422 110.649 92.6068 111.123 92.4522 111.587C92.3168 112.051 92.1718 112.515 92.0172 112.979C91.8818 113.424 91.7272 113.878 91.5532 114.342C91.3792 114.787 91.2148 115.251 91.0602 115.734L87.2322 126H82.3602ZM86.1882 122.114L87.7252 118.402H97.0632L98.5712 122.114H86.1882ZM104.671 126V121.853H108.093V109.847H104.671V105.7H116.474V109.847H113.023V121.853H116.474V126H104.671Z",
    fill: "url(#paint0_linear_1074_13624)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1074_13624",
    x: 0.0999985,
    y: 0.0999985,
    width: 196.8,
    height: 200.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30.45
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1074_13624"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1074_13624",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1074_13624",
    x1: 101,
    y1: 130,
    x2: 78.4966,
    y2: 107.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.37f803e18eaf08a83680f6918a52adc1.svg";
export { ForwardRef as ReactComponent };